import { Controller } from "@hotwired/stimulus"

// Bulk Sync Controller - Handles bulk Salesforce sync operations
export default class extends Controller {
  connect() {
    console.log("Bulk sync controller connected")
  }

  async syncPending(event) {
    event.preventDefault()
    await this.performBulkSync('pending', 'Retrying failed syncs...')
  }

  async syncEligible(event) {
    event.preventDefault()
    await this.performBulkSync('eligible', 'Syncing eligible applications...')
  }

  async performBulkSync(type, message) {
    const button = event.target
    const originalText = button.innerHTML
    
    try {
      // Show loading state
      button.disabled = true
      button.innerHTML = `
        <svg class="w-4 h-4 mr-2 animate-spin" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
        ${message}
      `

      const response = await fetch(`/admin/salesforce/bulk_sync/${type}`, {
        method: 'POST',
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        }
      })

      if (response.ok) {
        const data = await response.json()
        this.showSuccess(button, data.message || 'Sync initiated successfully')
        
        // Trigger refresh of counters
        this.triggerCounterRefresh()
        
      } else {
        const errorText = await response.text()
        console.error("Bulk sync failed:", response.status, errorText)
        throw new Error(`HTTP ${response.status}: ${response.statusText}`)
      }

    } catch (error) {
      console.error("Error performing bulk sync:", error)
      this.showError(button, 'Sync failed. Please try again.')
    } finally {
      // Restore button after delay
      setTimeout(() => {
        button.disabled = false
        button.innerHTML = originalText
      }, 3000)
    }
  }

  showSuccess(button, message) {
    button.innerHTML = `
      <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      ${message}
    `
    button.classList.remove('bg-blue-600', 'hover:bg-blue-700', 'bg-green-600', 'hover:bg-green-700')
    button.classList.add('bg-green-500')
  }

  showError(button, message) {
    button.innerHTML = `
      <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.96-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
      </svg>
      ${message}
    `
    button.classList.remove('bg-blue-600', 'hover:bg-blue-700', 'bg-green-600', 'hover:bg-green-700')
    button.classList.add('bg-red-500')
  }

  triggerCounterRefresh() {
    // Trigger custom event to refresh all live counters
    document.dispatchEvent(new CustomEvent('salesforce:counters:refresh'))
  }
}